"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorMessageCreator = exports.ConfigError = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _config = require("./config");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var errorMessage = 'failed in request';
var apiPath = typeof location !== 'undefined' ? location.host : '';

var ConfigError = /*#__PURE__*/function (_Error) {
  (0, _inherits2["default"])(ConfigError, _Error);

  var _super = _createSuper(ConfigError);

  function ConfigError(_ref) {
    var _cdnConfigs;

    var _this;

    var message = _ref.message,
        env = _ref.env,
        requestType = _ref.requestType,
        type = _ref.type;
    (0, _classCallCheck2["default"])(this, ConfigError);
    var finallyMessage = "env ".concat(env, " ").concat(message || errorMessage);
    _this = _super.call(this, finallyMessage);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "type", 'error');
    _this.env = env || 'product';
    _this.requestType = requestType;
    _this.type = type;
    _this.host = ['oss', 's3'].includes(requestType) ? _config.cdnConfigs === null || _config.cdnConfigs === void 0 ? void 0 : (_cdnConfigs = _config.cdnConfigs[requestType]) === null || _cdnConfigs === void 0 ? void 0 : _cdnConfigs.host : apiPath;
    return _this;
  }

  return (0, _createClass2["default"])(ConfigError);
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));

exports.ConfigError = ConfigError;
var errorMessageCreator = {
  detect: function detect(_ref2) {
    var host = _ref2.host,
        method = _ref2.method;
    return "detect cdn ".concat(host, " ").concat(method, " alive failed");
  },
  failedToFetch: function failedToFetch(_ref3) {
    var nextMethod = _ref3.nextMethod,
        currentMethod = _ref3.currentMethod;

    if (currentMethod && nextMethod) {
      return "current method ".concat(currentMethod, " is unavailable, backup to ").concat(nextMethod);
    }

    return "current method ".concat(currentMethod, " is unavailable, no backup method");
  },
  newtowkFailed: function newtowkFailed() {
    return 'network error';
  }
};
exports.errorMessageCreator = errorMessageCreator;